class GoogleTagManagerApi {
    constructor(config = {}) {
        /**
         * Default config
         */
        this._config = config
        /**
         * Defines if the component is ready
         */
        this._isReady = false

        /**
         * Initializes component
         *
         * @param {object} args - Custom parameters
         * @param {object} data - Built-in data utilities (addLayer: addLayer.bind)
         */
        this.initialize = () => (this._isReady = true)

        /**
         * Checks if can add layer
         *
         * @returns {Promise<boolean>}
         */
        this._canAddLayer = async () => {
            return new Promise((resolve, reject) => {
                if (typeof window !== 'undefined' && window.dataLayer) {
                    resolve(true)
                }
                reject(false)
            })
        }

        /**
         * Pushes data to google tag manager
         *
         * @param {object} data - Object to be pushed to google tag manager
         * @returns {object} - sent object
         */
        this._pushLayer = (data) => {
            window.dataLayer.push(data)
            return data
        }

        /**
         * Checks if can add layer and starts to push it
         *
         * @param {object} data - Object to be pushed to google tag manager
         * @returns {object} - sent object
         */
        this.addLayer = async (data) => (await this._canAddLayer()) && this._pushLayer(data)
    }
}

export default GoogleTagManagerApi
